export const CANON_ROOT = 'https://mattlean.com'
export const TITLE_SUFFIX = ' | Matt Lean'
export const NO_MATCH_TITLE = `404'd!! FiLE NOT FOUND${TITLE_SUFFIX}`
